export default "__VITE_ASSET__94e67374__"